<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/special/bug-circle.svg" [width]="96" [height]="96" size="3"></app-svg>

  <h1>Debug Mode</h1>
  <p>
    Please reproduce the issue and then download the debug-file on the bottom left of the screen. Finally, send us that
    file through the support chat window.
  </p>

  <button
    appButton
    name="confirm"
    location="debug-dialog"
    color="orange"
    data-test-id="delete-confirmation"
    (click)="close()"
    height="4"
    size="3"
    shape="round"
    weight="bold"
    spacing="full"
  >
    <span>Start</span>
  </button>
  <a
    href="https://help.picflow.com/en/articles/8201598"
    target="_blank"
    appButton
    name="learn-more"
    location="debug-dialog"
    color="simple-gray"
    size="3"
    height="1"
    weight="bold"
    shape="round"
    class="sub-cta"
    [center]="true"
    >Learn more</a
  >
</div>
